import { useMergeRefs } from '@chakra-ui/react-v2';
import { forwardRef, useRef } from 'react';

import { Textarea, type TextareaProps } from '@frontend/legacy-components';

import { useAutoResizeTextarea } from '../hooks';

export const AutoResizeTextarea = forwardRef<
  HTMLTextAreaElement,
  TextareaProps
>((props, forwardedRef) => {
  const internalRef = useRef<HTMLTextAreaElement>(null);
  useAutoResizeTextarea(internalRef);
  const mergedRef = useMergeRefs(forwardedRef, internalRef);
  return <Textarea ref={mergedRef} {...props} />;
});
AutoResizeTextarea.displayName = 'AutoResizeTextarea';
